import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  getPetInfoByMicrochipNo,
  savePetsReportRegistration,
} from "../../../api/apimethods";
import { IPetReportRequests } from "../../../typings/interfaces/Requests/PetReportRequest";
import { countryMobileCodes } from "../../../scripts/countryMobileCodes";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useAuthService, useContextService } from "../../../services";
import { AxiosError } from "axios";
import { IAnimalTypesModel } from "../../../typings/models/AnimalTypesModel";
import fetchAnimalTypes from "../../../scripts/animalTypes";
import { NotifyType } from "../../../utils/NotifyType";
import { notify } from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../../components/molecules/Loader";

interface TabPetsReportProps {
  onSuccessfulSubmit: () => void;
}

const TabPetsReport: React.FC<TabPetsReportProps> = ({
  onSuccessfulSubmit,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const { message } = notify();
  const inputAnimalTypeRef = useRef(true);
  const [serviceType, setServiceType] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchErrorMessage, setSearchErrorMessage] = useState("");
  const [isSubmiting, setSubmiting] = useState(false);
  const [messageType, setMessageType] = useState<string>("danger");
  const [submitted, setSubmitted] = useState(false);
  const [serviceTypeSelected, setServiceTypeSelected] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [validEmail, setValidEmail] = useState(true);
  const [microchipNo, setMicrochipNo] = useState("");
  const [description, setDescription] = useState("");
  const [dateandTimeWhenPetWasFound, setDateAndTimeWhenPetWasFound] =
    useState("");
  const [isCommunityCat, setisCommunityCat] = useState<any>(null);
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const [animalTypeLabel, setAnimalTypeLabel] = useState("");
  const [animalType, setAnimalType] = useState("");
  const [animalTypes, setAnimalTypes] = useState<IAnimalTypesModel[]>([]);
  const [applicantEmailAddress, setApplicantEmailAddress] = useState("");
  const [applicantMobileNumber, setApplicantMobileNumber] = useState("");
  const [remarks, setRemarks] = useState("");
  const [locationOfPets, setLocationOfPets] = useState("");
  const [applicantIDNumber, setApplicantIDNumber] = useState("");
  const [applicantName, setApplicantName] = useState("");
  const [applicantIdType, setapplicantIdType] = useState("");
  const [isMicrochipValid, setIsMicrochipValid] = useState(true);
  const [isMicrochipValidOversease, setIsMicrochipValidOversease] =
    useState(true);
  const [isMinValidDate, setisMinValidDate] = useState(true);
  const [mobilecode, setMobileCode] = useState("+65");
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [searchMicrochipNo, setSearchMicrochipNo] = useState("");
  const [microchipNoExists, setMicrochipNoExists] = useState(false);
  const [displayForm, setDisplayForm] = useState(false);
  const [isTimeValid, setTimeValid] = useState(true);
  const [timeWhenPetWasFound, setTimeWhenPetWasFound] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [loginType, setLoginType] = useState("SingPass");

  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Set it to today
  const maxdate = currentDate.toISOString().split("T")[0];
  const minDate = "1990-01-01";
  const transferType = "PetsRegistration";
  const inputUserRef = useRef(true);

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;
      user.role = "SingPass";
      if (user !== undefined) {
        if (user.role != undefined) setLoginType(user.role);
        if (user.role === "SingPass") {
          if (user.name != undefined) setApplicantName(user.name);
          if (user.idNo != undefined) setApplicantIDNumber(user.idNo);
          setServiceType(1);

          setapplicantIdType("2");
        }
        if (user.role === "CorpPass") {
          if (user.idType != undefined) setapplicantIdType("4");
          if (user.uen != undefined) setApplicantIDNumber(user.uen);
        }
        if (user.contactNo != undefined) {
          setMobileCode(user.contactNo.substring(0, 3));
          setApplicantMobileNumber(user.contactNo.substring(3));
        } else {
          setApplicantMobileNumber(""); // Set empty string if newownerphnumber is null or undefined
          setMobileCode("+65");
        }
        if (user.email != undefined) setApplicantEmailAddress(user.email);
      }
    }
  });
  useEffect(() => {
    if (inputAnimalTypeRef.current) {
      inputAnimalTypeRef.current = false;
      const fetchAnimalType = async () => {
        const animalTypes = await fetchAnimalTypes();
        setAnimalTypes(animalTypes);
      };

      fetchAnimalType();
    }
  }, []);

  const handleAnimalTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedAnimalType = event.target.value;
    const selectedAnimalTypelabel =
      animalTypes.find((type) => type.id === selectedAnimalType)?.name ?? "";
    setAnimalType(selectedAnimalType);
    setAnimalTypeLabel(selectedAnimalTypelabel);
  };

  const convertTo24HourFormat = (time: any) => {
    const [hours, minutes] = time.split(":");
    let hoursInt = parseInt(hours, 10);
    if (hoursInt < 12 && time.includes("PM")) {
      hoursInt += 12;
    }
    return `${hoursInt.toString().padStart(2, "0")}:${minutes}`;
  };

  const isValidTime = (time: any) => {
    const selectedTime = new Date(`2000-01-01T${time}`);
    const minTime = new Date(`2000-01-01T09:00`);
    const maxTime = new Date(`2000-01-01T17:00`);

    return selectedTime >= minTime && selectedTime <= maxTime;
  };

  const isAllValidation = () => {
    return (
      applicantName &&
      applicantIdType &&
      applicantIDNumber &&
      locationOfPets &&
      validEmail &&
      validMobileNo &&
      dateandTimeWhenPetWasFound &&
      applicantMobileNumber &&
      applicantEmailAddress &&
      animalType &&
      description &&
      checkboxChecked &&
      timeWhenPetWasFound
    );
  };

  const handleApplicantIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedApplicantIdType = event.target.value;
    setapplicantIdType(selectedApplicantIdType);
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setApplicantEmailAddress(value);
    const isValidEmail = pattern.test(value);

    if (validEmail !== isValidEmail) {
      setValidEmail(isValidEmail);
    }
  };

  const handleMicrochipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    const isValid = /^[a-zA-Z0-9]{3,100}$/.test(value);
    setIsMicrochipValid(isValid);
    setMicrochipNo(value);
    setSearchMicrochipNo(value);
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    if (!selectedDate) {
      setisValidDate(false);
      setSearchErrorMessage("Please enter a date.");
      setDateAndTimeWhenPetWasFound("");
      return;
    }

    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (selectedDateObj > maxdateObj) {
      setisValidDate(false);
      setSearchErrorMessage("Date cannot be later than today's date.");
      setDateAndTimeWhenPetWasFound("");
      return;
    } else {
      setisValidDate(true);
    }
    if (selectedDateObj < mindateObj) {
      setisMinValidDate(false);
      setSearchErrorMessage("Please enter a valid year.");
      setDateAndTimeWhenPetWasFound("");
      return;
    } else {
      setisMinValidDate(true);
    }

    setDateAndTimeWhenPetWasFound(selectedDate);
    setSearchErrorMessage("");
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^\d+$/;

    if (pattern.test(value) || value === "") {
      setApplicantMobileNumber(value);

      const isValidMobile =
        mobilecode === "+65"
          ? /^[0-9]{8}$/.test(value)
          : /^[0-9]{10,15}$/.test(value);
      if (validMobileNo !== isValidMobile) {
        setValidMobileNo(isValidMobile);
      }
    }
  };
  const handleSearch = async () => {
    if (
      searchMicrochipNo !== "" &&
      user.idNo !== undefined &&
      user.idNo !== "" &&
      user.idType !== undefined &&
      user.idType !== ""
    ) {
      try {
        const microchipRegistration = await getPetInfoByMicrochipNo(
          searchMicrochipNo,
          user.idNo,
          user.idType,
          3,
          user?.email
        );

        const response = microchipRegistration.data.response;

        if (response.data) {
          setMicrochipNoExists(true);
          setMessageType("success");
          setSearchErrorMessage(
            `Microchip No. ${searchMicrochipNo} is REGISTERED with National Parks Board/Animal & Veterinary Service (NParks/AVS)`
          );
        } else {
          setMicrochipNoExists(false);
          setMessageType("danger");
          setSearchErrorMessage(
            `Microchip No. ${searchMicrochipNo} is NOT REGISTERED with National Parks Board/Animal & Veterinary Service (NParks/AVS)`
          );
        }

        if (response.message) {
          setSearchErrorMessage(response.message);

          if (response.code === 200) {
            setMessageType("success");
          } else {
            setMessageType("danger");
          }
        }

        setMicrochipNo(searchMicrochipNo);
      } catch (error) {
        if (error instanceof AxiosError) {
          setSearchErrorMessage(
            error.response?.data?.message ||
              "Error occurred during the search. Please try again."
          );
        } else {
          setSearchErrorMessage(
            "Error occurred during the search. Please try again."
          );
        }
        setMessageType("danger");
        console.error(error);
      }
    } else {
      setSearchErrorMessage("Please enter a valid Microchip No.");
      setMessageType("danger");
    }
  };
  const handleDisplay = (event: React.ChangeEvent<HTMLInputElement>) => {
    var value = event.target.value;
    setSelectedOption(value);
    if (value == "1") {
      setDisplayForm(true);
    } else {
      setDisplayForm(false);
    }
  };

  const PetsReportRegRequestData: IPetReportRequests = {
    ApplicantName: applicantName,
    ApplicantIDType: applicantIdType,
    ApplicantIDNumber: applicantIDNumber,
    LocationOfPets: locationOfPets,
    Remarks: remarks,
    ApplicantMobileNumber: mobilecode + applicantMobileNumber,
    ApplicantEmailAddress: applicantEmailAddress,
    animalType: animalType,
    DateWhenPetWasFound: dateandTimeWhenPetWasFound,
    TimeWhenPetWasFound: timeWhenPetWasFound,
    MicrochipNo: microchipNo,
    Description: description,
    isCommunityCat: isCommunityCat,
    LoginType:
      user.role === "SingPass" ? "1" : user.role === "CorpPass" ? "2" : "3",
  };

  const resetForm = () => {
    setapplicantIdType("");
    setisCommunityCat("");
    setApplicantName("");
    setApplicantIDNumber("");
    setApplicantMobileNumber("");
    setApplicantEmailAddress("");
    setRemarks("");
    setDateAndTimeWhenPetWasFound("");
    setTimeWhenPetWasFound("");
    setDescription("");
    setLocationOfPets("");
    setMicrochipNo("");
    setCheckboxChecked(false);
    setSearchErrorMessage("");
    setSearchMicrochipNo("");
    setDisplayForm(false);
    setSelectedOption("");
  };

  const handleSubmit = async (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setSubmitted(true);
    try {
      setDisableSubmit(true);

      if (isAllValidation()) {
        var response = await savePetsReportRegistration(
          PetsReportRegRequestData
        );
        if (response?.data) {
          setSubmiting(false);
          const successMessage =
            "You have registered a lost report with Microchip No. " +
            microchipNo;
          alert(successMessage);
          resetForm();
          onSuccessfulSubmit();
        } else {
          setSubmiting(false);
          setErrorMessage("An error occurred. Please try again.");
        }
      } else {
        setErrorMessage("Please fill in all required fields.");
      }
    } catch (error) {
      setSubmiting(false);
      console.error(error);
    }

    setDisableSubmit(false);
  };

  return (
    <>
      <h2 className="pb-2">Microchip Submission Enquiry</h2>
      <div className="inst-cnt mt-4 mb-2">
        <div className="mb-2 ">
          <label htmlFor="exampleFormControlInput1" className="form-label mb-2">
            Microchip No.
          </label>
          <input
            type="text"
            className="form-control"
            id="microchipNo"
            placeholder=""
            maxLength={100}
            value={searchMicrochipNo}
            onChange={handleMicrochipChange}
          />
          {searchErrorMessage && (
            <div className={`alert alert-${messageType} mt-2`} role="alert">
              {searchErrorMessage}
            </div>
          )}
        </div>
        <div className="float-right">
          <button
            type="button"
            className="btn btn-success d-block mt-4 float-right"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
        {searchErrorMessage && (
          <p className="invalid-feedback">{searchErrorMessage}</p>
        )}
        <div className="inst-cnt mt-4 mb-2">
          <div className="row">
            <div className="col-lg-8">
              <label className="form-check-label">
                Do you want to submit Lost and Found Report?
              </label>
            </div>
            <div className="col-lg-4">
              <div className="form-checked">
                <label htmlFor="healthyYes" className="form-check-label">
                  <input
                    type="radio"
                    id="display"
                    name="display"
                    value="1"
                    className="form-check-input"
                    checked={selectedOption === "1"}
                    onChange={handleDisplay}
                    required
                  />
                  Yes
                </label>
                <label htmlFor="healthyNo" className="form-check-label">
                  <input
                    type="radio"
                    id="display"
                    name="display"
                    value="2"
                    className="form-check-input"
                    checked={selectedOption === "2"}
                    onChange={handleDisplay}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {displayForm && (
        <div>
          <h2 className="pb-2">Registration</h2>
          <div className="inst-cnt mt-4 mb-2">
            <span className="est-time">
              <i className="fas fa-clock"></i> Estimated time to complete: 15
              mins
            </span>
          </div>
          <form
            className="row g-3 needs-validation"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="passport-details" id="passport">
              <h2 className="pt-2 pb-0">Applicant Information</h2>
              <div className="inst-cnt mt-2">
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    1. Applicant Name <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="applicantName"
                    placeholder=""
                    maxLength={355}
                    value={applicantName}
                    onChange={(event) => setApplicantName(event.target.value)}
                    required
                  />
                  {submitted && !applicantName && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Applicant Name.
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    2. Applicant ID Type <span className="star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="applicantIdType"
                    value={applicantIdType}
                    onChange={handleApplicantIdTypeChange}
                    required
                  >
                    <option value=""></option>
                    <option value="2">NRIC</option>
                    <option value="1">FIN</option>
                    <option value="4">UEN</option>
                  </select>

                  {submitted && !applicantIdType && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Applicant ID Type.
                    </div>
                  )}
                </div>

                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    3. Applicant ID Number <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="applicantIDNumber"
                    placeholder=""
                    maxLength={355}
                    value={applicantIDNumber}
                    onChange={(event) =>
                      setApplicantIDNumber(event.target.value)
                    }
                    required
                  />

                  {submitted && !applicantIDNumber && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Applicant ID Number .
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    4. Applicant Mobile Number <span className="star">*</span>
                  </label>

                  <div className="row">
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="mobilecode"
                        value={mobilecode}
                        onChange={(e) => setMobileCode(e.target.value)}
                        required
                      >
                        {countryMobileCodes.map((code: any) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-10">
                      <input
                        type="text"
                        aria-describedby="emailHelp"
                        className={`form-control ${
                          !validMobileNo ? "is-invalid" : ""
                        }`}
                        id="applicantMobileNumber"
                        placeholder=""
                        pattern="[0-9]+"
                        value={applicantMobileNumber}
                        onChange={mobileNoHandler}
                        maxLength={mobilecode === "+65" ? 8 : 66}
                        required
                      />

                      {submitted && !applicantMobileNumber && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please provide valid Contact No.
                        </div>
                      )}

                      {submitted &&
                        applicantMobileNumber &&
                        mobilecode === "+65" &&
                        !validMobileNo && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Invalid mobile no. e.g. +6591234567
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    5. Applicant Email Address <span className="star">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="applicantEmailAddress"
                    placeholder=""
                    maxLength={255}
                    value={applicantEmailAddress}
                    onChange={handleEmailChange}
                    required
                  />

                  {submitted && !applicantEmailAddress && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Applicant Email.
                    </div>
                  )}

                  {submitted && applicantEmailAddress && !validEmail && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Invalid email format. eg. abc@de.lk
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    6. Animal Type <span className="star">*</span>{" "}
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="animalType"
                    value={animalType}
                    onChange={handleAnimalTypeChange}
                    required
                  >
                    <option value=""></option>
                    {animalTypes.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>

                  {submitted && !animalType && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Animal Type.
                    </div>
                  )}
                </div>

                {animalType === "e0df8145-1d5d-ed11-9561-0022485935af" && (
                  <div className="mb-2">
                    <>
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Community Cat <span className="star">*</span>
                      </label>

                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      ></label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isCommunityCat"
                          value={1}
                          id="communityCatYes"
                          checked={isCommunityCat === 1}
                          onChange={() => setisCommunityCat(1)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="communityCatYes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isCommunityCat"
                          value={0}
                          id="communityCatNo"
                          checked={isCommunityCat === 0}
                          onChange={() => setisCommunityCat(0)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="communityCatNo"
                        >
                          No
                        </label>
                      </div>
                    </>
                    {submitted && isCommunityCat === null && (
                      <div className="error-message">
                        <FontAwesomeIcon
                          className="me-1"
                          icon={faCircleExclamation}
                        />
                        Please select a Community Cat option.
                      </div>
                    )}
                  </div>
                )}
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    7. Microchip Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="microchipNo"
                    placeholder=""
                    maxLength={100}
                    value={microchipNo}
                    onChange={handleMicrochipChange}
                    required
                  />

                  {/* {submitted && microchipNo && !isMicrochipValid && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter a valid Microchip No. Letters: A to Z,
                      Digits: 0 to 9
                    </div>
                  )} */}

                  {!isMicrochipValid && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please enter a valid Microchip No. Letters: A to Z,
                      Digits: 0 to 9
                    </div>
                  )}
                </div>

                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    8. Description of pet <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="description"
                    placeholder=""
                    maxLength={2000}
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                    required
                  />

                  {submitted && !description && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Description of pet.
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="dateandTimeWhenPetWasFound"
                    className="form-label mb-2"
                  >
                    9. Date And Time when Pet was Found{" "}
                    <span className="star">*</span>
                  </label>
                  <div className="row">
                    <div className="col-lg-6">
                      <input
                        type="date"
                        className={`form-control ${
                          !isValidDate || !isMinValidDate ? "is-invalid" : ""
                        }`}
                        id="dateandTimeWhenPetWasFound"
                        value={dateandTimeWhenPetWasFound}
                        max={maxdate}
                        min={minDate}
                        onChange={handleDateChange}
                        required
                      />
                      {submitted && !dateandTimeWhenPetWasFound && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please enter the date when the pet was found.
                        </div>
                      )}

                      {submitted &&
                        dateandTimeWhenPetWasFound &&
                        !isValidDate && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Date cannot be later than today's date.
                          </div>
                        )}

                      {submitted &&
                        dateandTimeWhenPetWasFound &&
                        isValidDate &&
                        !isMinValidDate && (
                          <div className="error-message">
                            <FontAwesomeIcon
                              className="me-1"
                              icon={faCircleExclamation}
                            />
                            Please enter a valid year (before the min date).
                          </div>
                        )}
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="time"
                        className={`form-control ${
                          !isTimeValid ? "is-invalid" : ""
                        }`}
                        id="timeWhenPetWasFound"
                        value={convertTo24HourFormat(timeWhenPetWasFound)}
                        onChange={(event) =>
                          setTimeWhenPetWasFound(event.target.value)
                        }
                        required
                        pattern="^(0[9]|1[0-6]):[0-5][0-9]$"
                      />
                      {submitted && !timeWhenPetWasFound && (
                        <div className="error-message">
                          <FontAwesomeIcon
                            className="me-1"
                            icon={faCircleExclamation}
                          />
                          Please enter time when pet was found.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    10. Location of Pet <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="locationOfPets"
                    placeholder=""
                    maxLength={2000}
                    value={locationOfPets}
                    onChange={(event) => setLocationOfPets(event.target.value)}
                    required
                  />

                  {submitted && !locationOfPets && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please provide Location of Pet.
                    </div>
                  )}
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    11. Remarks
                  </label>
                  <textarea
                    className="form-control"
                    id="remarks"
                    placeholder=""
                    maxLength={200}
                    value={remarks}
                    onChange={(event) => setRemarks(event.target.value)}
                  />
                  <p>{remarks ? remarks.length : 0}/200</p>
                </div>
              </div>
              <h2>Declaration</h2>
              <div className="inst-cnt mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={checkboxChecked}
                    onChange={handleCheckboxChange}
                    id="flexCheckDefault"
                    required
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    All the information given is correct and true to the best of
                    my knowledge.
                  </label>

                  {submitted && !checkboxChecked && (
                    <div className="error-message">
                      <FontAwesomeIcon
                        className="me-1"
                        icon={faCircleExclamation}
                      />
                      Please confirm the declaration checkbox
                    </div>
                  )}
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-success d-block mt-4"
                onClick={handleSubmit}
              >
                Submit
              </button>
              {isSubmiting && <Loader />}
              {errorMessage && (
                <p className="invalid-feedback">{errorMessage}</p>
              )}
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default TabPetsReport;
